<script setup>
  const { event } = defineProps(['event']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <UpcomingEventCard high :event="event">
    <h2>
      <span>{{ useTournamentSize(event.size) }}</span> {{ event.tournament_title }}
    </h2>
  </UpcomingEventCard>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  .event-card {
    @include break-small {
      :deep(.right-side) {
        margin-top: px(-48);
        .top {
          h3 {
            margin-top: px(4);
          }
        }
      }
    }
  }

  h2 {
    position: absolute;

    top: 44%;
    transform: translateY(-50%);

    padding: 0 px(32);

    width: 100%;
    margin-top: px(20);

    //max-width: 45vw;
    @include heroic-heavy(6vw);
    text-align: center;

    @include break-large {
      max-width: none;
    }

    @include break-small {
      position: static;
      transform: none;

      display: flex;
      flex-direction: column;

      @include heroic-bold(px(32));
      span {
        @include heroic-heavy(px(80));
        margin-bottom: px(8);
      }
    }
  }
</style>
